import { ArticleType } from '@wix/answers-api';
import { Badge } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { FunctionComponent } from 'react';
import { DATA_HOOKS } from '../../../../../dataHooks';
import { ArticleSearchResultDocumentType } from '../../../../../types';

export type SourceTypeTagProps = {
  type?: ArticleType;
  docType: ArticleSearchResultDocumentType;
};

export const SourceTypeTag: FunctionComponent<SourceTypeTagProps> = ({
  type,
  docType,
}) => {
  const { t } = useTranslation();
  const isWixDocument =
    docType === ArticleSearchResultDocumentType.WIX_DOCS_ARTICLE;
  const isCommunityPost =
    docType === ArticleSearchResultDocumentType.WIX_FORUM_TOPIC;

  const getArticleTypeTitle = (articleType?: ArticleType): string => {
    switch (articleType) {
      case ArticleType.FEATURE_REQUEST:
        return t('feature.request.title');
      case ArticleType.KNOWN_ISSUE:
        return t('known.issue.title');
      case ArticleType.ARTICLE:
      default:
        if (isWixDocument) {
          return t('search.results.document.title');
        } else if (isCommunityPost) {
          return t('search.results.community.forum.title');
        }
        return t('article.title');
    }
  };

  return (
    <Badge
      dataHook={DATA_HOOKS.SEARCH_RESULT_SOURCE_TYPE_TAG}
      size="tiny"
      skin="neutralLight"
      type="solid"
    >
      {getArticleTypeTitle(type)}
    </Badge>
  );
};
